module.exports = __webpack_public_path__ + "img/nothing-null.7cb36a4a.png";